/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Стадия обновления</h2>
    <p className={styles.description}>
      Обновление может быть вызвано измением <code className={styles.code}>state</code> самого компонента или
      передаваемых ему <code className={styles.code}>props</code>. При обновлении необходимо перерендерить компонент,
      что ведет к вызову следующих методов.{' '}
    </p>
    <CopyBlock
      text={`shouldComponentUpdate(nextProps, nextState) {}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <ul className={styles.list}>
      <li className={styles.list__item}>Не вызывается при инициализации компонента</li>
      <li className={styles.list__item}>Вызывается перед ре-рендером уже существующего компонента</li>
      <li className={styles.list__item}>Необходим исключительно для оптимизации процесса рендера</li>
      <li className={styles.list__item}>
        По умолчанию <code className={styles.code}>render</code> происходит каждый раз при новых{' '}
        <code className={styles.code}>props</code> или <code className={styles.code}>state</code>
      </li>
      <li className={styles.list__item}>
        Позволяет сравнить текущие и предыдущие <code className={styles.code}>state</code> и{' '}
        <code className={styles.code}>props</code>, вернув <code className={styles.code}>true</code> или{' '}
        <code className={styles.code}>false</code> указывая React есть ли необходимость обновлять компонент
      </li>
      <li className={styles.list__item}>
        Если вернет <code className={styles.code}>false</code> то не произойдет{' '}
        <code className={styles.code}>render()</code> и <code className={styles.code}>componentDidUpdate()</code>
      </li>
      <li className={styles.list__item}>
        Нельзя вызывать <code className={styles.code}>setState()</code>
      </li>
      <li className={styles.list__item}>
        Использовать необходимо очень аккуратно, только после замеров производительности, в противном случае может
        привести к обратному эффекту
      </li>
      <li className={styles.list__item}>
        Возможно стоит заменить на <code className={styles.code}>React.PureComponent</code>, который будет делать
        поверхностное сравнение <code className={styles.code}>props</code>. Но только после замеров производительности
      </li>
    </ul>
    <CopyBlock
      text={`getSnapshotBeforeUpdate(prevProps, prevState) {}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <ul className={styles.list}>
      <li className={styles.list__item}>Вызывается перед тем, как все изменения готовы к добавлению в DOM</li>
      <li className={styles.list__item}>
        Можно использовать для получения DOM-значений перед обновлением, к примеру текущую позицию скрола
      </li>
      <li className={styles.list__item}>
        То что вернет этот метод, будет передано как третий параметр в{' '}
        <code className={styles.code}>componentDidUpdate()</code>
      </li>
    </ul>
    <CopyBlock
      text={`componentDidUpdate(prevProps, prevState, snapshot) {}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <ul className={styles.list}>
      <li className={styles.list__item}>Вызывается сразу после обновления компонента</li>
      <li className={styles.list__item}>Не вызывается при первоначальном рендере компонента</li>
      <li className={styles.list__item}>
        Можно вызывать <code className={styles.code}>setState()</code>, обязательно обернув его в условие проверки
        изменения предыдущих и следующих <code className={styles.code}>props</code> и{' '}
        <code className={styles.code}>state</code>, чтобы не возник бесконечный цикл.
      </li>
      <li className={styles.list__item}>Можно делать HTTP-запросы</li>
      <li className={styles.list__item}>Можно передавать сторонним библиотекам новые данные</li>
      <li className={styles.list__item}>
        Если в компоненте есть <code className={styles.code}>getSnapshotBeforeUpdate()</code>, то значение возвращаемое
        им будет передано третим аргументом <code className={styles.code}>snapshot</code>, в противном случае его
        значением будет <code className={styles.code}>undefined</code>
      </li>
    </ul>
  </section>
))
